import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

const ToggleField = ({ text, name, value, toggaleHandleChange, disabled }) => {
  const { setFieldValue } = useFormikContext();
  const [toggle, setToggle] = useState(value);

  useEffect(() => {
    setToggle(Boolean(value));
  }, [value]);

  const handleClick = () => {
    if (!disabled) {
      const nextValue = !toggle;
      setToggle(nextValue);
      setFieldValue(name, nextValue);
      toggaleHandleChange &&
        toggaleHandleChange({
          target: {
            name,
            value: nextValue,
          },
        });
    }
  };

  return (
    <div
      className={`w-full rounded-xl border px-4 py-3 transition-all ${
        disabled
          ? "cursor-not-allowed border-gray-200 bg-gray-100 opacity-70"
          : toggle
          ? "border-[--color--11] bg-[rgba(227,78,78,0.08)]"
          : "border-gray-200 bg-white"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="text-left">
          <p className="text-sm font-medium text-[--text-color3]">{text}</p>
          <p className="text-xs text-[--color-tbl-data]">
            {toggle ? "Visible to customers" : "Hidden from customers"}
          </p>
        </div>

        <button
          type="button"
          onClick={handleClick}
          disabled={disabled}
          aria-pressed={toggle}
          aria-label={text}
          className={`relative h-7 w-12 rounded-full transition-colors ${
            disabled
              ? "cursor-not-allowed"
              : "cursor-pointer hover:opacity-90"
          } ${toggle ? "bg-[--color--11]" : "bg-gray-300"}`}
        >
          <span
            className={`absolute top-1 h-5 w-5 rounded-full bg-white shadow transition-all ${
              toggle ? "left-6" : "left-1"
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default ToggleField;
